// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/routes/BlogImage.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/routes/BlogImage.tsx");
  import.meta.hot.lastModified = "1716289823159.3997";
}
// REMIX HMR END

export default function BlogImage({
  src,
  caption,
  alt
}) {
  return <>
      <img src={src} alt={alt} className="not-prose mb-4" />
      {caption ? <span className="mt-2 text-gray-600">{caption}</span> : null}
    </>;
}
_c = BlogImage;
var _c;
$RefreshReg$(_c, "BlogImage");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;